/*
  biobio-lp.js — comportamentos das sections de LP.
  Plano: docs/plans/2026-06-09-lp-renata.md.

  1. CTA âncora do hero ([data-lp-anchor]): scroll suave com respeito a
     prefers-reduced-motion e foco programático no alvo (a11y). O offset do
     header sticky vem do scroll-margin-top no CSS do alvo.
  2. Video-row: garante um vídeo tocando por vez (listener de play em capture).

  GUARD de execucao unica (bug 11/06): o Shopify NAO dedupa <script> tags e
  este arquivo e incluido por mais de uma section da LP (hero + videos). Sem
  o guard, os listeners delegados registram em dobro e o botao de som
  liga/desliga no MESMO clique (som nunca ativava).
*/

(() => {
  if (window.__biobioLpInit) return;
  window.__biobioLpInit = true;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-lp-anchor]');
    if (!link) return;

    const hash = link.getAttribute('href');
    if (!hash || hash.charAt(0) !== '#') return;

    const target = document.getElementById(hash.slice(1));
    if (!target) return;

    event.preventDefault();

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });

    if (!target.hasAttribute('tabindex')) {
      target.setAttribute('tabindex', '-1');
    }
    target.focus({ preventScroll: true });

    if (history.replaceState) {
      history.replaceState(null, '', hash);
    }
  });

  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const muteVideo = (video) => {
    video.muted = true;
    const button = video.closest('.lp-videos__frame')?.querySelector('[data-lp-sound]');
    if (button) {
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', 'Ativar som');
      button.classList.remove('is-on');
    }
  };

  const initVideoRows = () => {
    const players = document.querySelectorAll('video.lp-videos__player[data-src]');
    if (!players.length) return;

    const load = (video) => {
      if (!video.src) video.src = video.dataset.src;
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting) {
              load(video);
              if (reduceMotion()) {
                video.setAttribute('controls', 'controls');
              } else if (!video.dataset.userPaused) {
                video.play().catch(() => {});
              }
            } else {
              video.pause();
              if (!video.muted) muteVideo(video);
            }
          });
        },
        { threshold: 0.4 }
      );
      players.forEach((video) => observer.observe(video));
    } else {
      players.forEach((video) => {
        load(video);
        video.setAttribute('controls', 'controls');
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoRows);
  } else {
    initVideoRows();
  }

  document.addEventListener('click', (event) => {
    const soundButton = event.target.closest('[data-lp-sound]');
    if (soundButton) {
      const video = soundButton.closest('.lp-videos__frame')?.querySelector('video.lp-videos__player');
      if (!video) return;

      if (video.muted) {
        document.querySelectorAll('video.lp-videos__player').forEach((other) => {
          if (other !== video) muteVideo(other);
        });
        if (!video.src && video.dataset.src) video.src = video.dataset.src;
        delete video.dataset.userPaused;
        video.muted = false;
        video.play().catch(() => {});
        soundButton.setAttribute('aria-pressed', 'true');
        soundButton.setAttribute('aria-label', 'Desativar som');
        soundButton.classList.add('is-on');
      } else {
        muteVideo(video);
      }
      return;
    }

    const player = event.target.closest('video.lp-videos__player');
    if (player && !player.hasAttribute('controls')) {
      if (player.paused) {
        delete player.dataset.userPaused;
        if (!player.src && player.dataset.src) player.src = player.dataset.src;
        player.play().catch(() => {});
      } else {
        player.dataset.userPaused = '1';
        player.pause();
      }
      return;
    }

    const arrow = event.target.closest('[data-lp-scroll]');
    if (arrow) {
      const carousel = arrow.closest('[data-lp-video-carousel]');
      const track = carousel?.querySelector('[data-lp-video-track]');
      if (!track) return;
      const card = track.querySelector('.lp-videos__item');
      const step = card ? card.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
      const direction = arrow.dataset.lpScroll === 'next' ? 1 : -1;
      track.scrollBy({ left: step * direction, behavior: reduceMotion() ? 'auto' : 'smooth' });
    }
  });

  document.addEventListener(
    'play',
    (event) => {
      const video = event.target;
      if (!(video instanceof HTMLVideoElement)) return;
      if (!video.classList.contains('lp-videos__player')) return;
      if (video.muted) return;

      document.querySelectorAll('video.lp-videos__player').forEach((other) => {
        if (other !== video && !other.muted) {
          other.pause();
          muteVideo(other);
        }
      });
    },
    true
  );
})();
